import styled, { css } from "styled-components"
import { Link } from "gatsby-plugin-react-intl"

export const RightSide = styled.div`
  width: calc(98% - 320px);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const TopDescription = styled.div`
  width: 100%;
  height: 43px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  p {
    &:first-child {
      font-weight: 700;
      font-size: 1.8rem;
      line-height: 2.7rem;
      letter-spacing: 0.05em;
    }
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 1.8rem;
    letter-spacing: 0.05em;
    color: #fdfdfd;
  }
`

export const CenterDescription = styled.div`
  width: 100%;
  height: 44px;
  display: flex;
  flex-wrap: nowrap;

  p {
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 2.1rem;
    letter-spacing: 0.05em;
    color: #fdfdfd;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    max-height: 44px;
  }
`

export const BottomDescription = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`

export const PriceBox = styled.div`
  height: 65px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  p {
    font-weight: 600;
    font-size: 2.3rem;
    line-height: 3.45rem;
    letter-spacing: 0.05em;
    color: #ce9638;

    &:first-child {
      font-weight: 400;
      font-size: 1.5rem;
      line-height: 2.25rem;
      letter-spacing: 0.05em;
      color: #fdfdfd;
      transform: scale(1);
      transition: all 0.2s ease-in-out;
    }
  }
`

export const GridPriceBox = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  p {
    color: #ce9638;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 2.3rem;
    letter-spacing: 0.05em;
    transition: all 0.2s ease-in-out;

    &:first-child {
      font-weight: 400;
      font-size: 1.5rem;
      letter-spacing: 0.05em;
      color: #fdfdfd;
      line-height: 2.3rem;
    }
  }
`

export const StyledLink = styled(Link)`
  text-decoration: none;
`

export const StyledLinkList = styled(Link)`
  padding: 30px 10%;
  &:hover {
    background: #111111;
    transition: all 0.2s ease-in-out;
  }
`

export const Main = styled.div`
  ${props =>
    props.displayType === "grid"
      ? css`
          cursor: pointer;
          width: 320px;
          height: 340px;
          display: flex;
          padding: 20px;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          gap: 0;
          background: #080808;
          transition: all 0.2s ease-in-out;
          border: 1px solid #080808;
          position: relative;

          & > img {
            width: 280px;
            height: 157.5px;
            transition: all 0.2s ease-in-out;
            object-fit: cover;
          }

          ${GridPriceBox} {
            & > p:last-child {
              transition: all 0.2s ease-in-out;
              background: linear-gradient(
                90deg,
                #eae69c 5.44%,
                #bb913c 68.77%,
                #b6872d 54.25%,
                #eae69c 100%
              );
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }

          &:hover {
            border: 1px solid #ce9638;
            transition: all 0.2s ease-in-out;

            & > img {
              transform: scale(1.13);
            }

            & > p:first-of-type {
              transition: all 0.2s ease-in-out;
              background: linear-gradient(
                90deg,
                #eae69c 5.44%,
                #bb913c 68.77%,
                #b6872d 54.25%,
                #eae69c 100%
              );
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }

            ${GridPriceBox} {
              & > p:last-child {
                transition: all 0.2s ease-in-out;
                background: linear-gradient(
                  90deg,
                  #eae69c 5.44%,
                  #bb913c 68.77%,
                  #b6872d 54.25%,
                  #eae69c 100%
                );
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }
          }
        `
      : css`
          width: 100%;
          /* padding: 30px 10%; */
          box-sizing: content-box;
          height: 180px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          gap: 2%;
          position: relative;
          transition: all 0.2s ease-in-out;
          cursor: pointer;

          ${PriceBox} {
            transition: all 0.2s ease-in-out;

            & > p:last-child {
              transition: all 0.2s ease-in-out;
              background: linear-gradient(
                90deg,
                #eae69c 5.44%,
                #bb913c 68.77%,
                #b6872d 54.25%,
                #eae69c 100%
              );
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }

          &:hover {
            /* background: #111111;
            transition: all 0.2s ease-in-out; */

            & > img {
              transform: scale(1.13);
            }

            ${TopDescription} {
              & > p:first-child {
                transition: all 0.2s ease-in-out;
                /* color: #ce9638; */
                color: transparent;
                background: linear-gradient(
                  120deg,
                  #eae69c 5.44%,
                  #bb913c 33.77%,
                  #b6872d 54.25%,
                  #eae69c 100%
                );
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                //test
              }
            }

            ${StyledLink} {
              & > button {
                background: linear-gradient(
                  79.38deg,
                  #eae69c 0.31%,
                  #bb913c 20.79%,
                  #eae69c 45.01%,
                  #bb913c 64.96%,
                  #b6872d 99.69%
                );
              }
            }

            ${PriceBox} {
              transition: all 0.2s ease-in-out;
              & > p:first-child {
                transition: all 0.2s ease-in-out;
                opacity: 0;
              }
              & > p:last-child {
                transition: all 0.2s ease-in-out;
                background: linear-gradient(
                  90deg,
                  #eae69c 5.44%,
                  #bb913c 68.77%,
                  #b6872d 54.25%,
                  #eae69c 100%
                );
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }
          }

          & > img {
            width: 320px;
            height: 180px;
            transition: all 0.2s ease-in-out;
            position: relative;
            object-fit: cover;
          }
        `}

  & > p {
    &:first-of-type {
      font-weight: 700;
      font-size: 1.7rem;
      line-height: 2.4rem;
      letter-spacing: 0.05em;
      text-align: center;
      max-height: 55px;
      overflow: hidden;
      text-overflow: ellipsis;
      transition: all 0.2s ease-in-out;
    }
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 1.8rem;
    letter-spacing: 0.05em;
    color: #fdfdfd;
    text-align: center;
  }
`
